import ApiConnection from "../ApiConnection";

abstract class ApiEndpoint {
    protected connection: ApiConnection;

    constructor(connection: ApiConnection) {
        this.connection = connection;
    }
}

export default ApiEndpoint;
